(() => {
  const shuffle = (items) => {
    const shuffled = [...items];

    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
    }

    return shuffled;
  };

  const hasCollection = (item, names) => {
    const handles = (item.dataset.collectionHandles || '').split(/\s+/);
    return handles.some((handle) => names.some((name) => handle.includes(name)));
  };

  const addUnique = (selected, item, limit) => {
    if (!item || selected.includes(item) || selected.length >= limit) return;
    selected.push(item);
  };

  document.querySelectorAll('[data-featured-rotation-list]').forEach((list) => {
    const excludedProductIds = new Set(
      Array.from(document.querySelectorAll('product-info[data-update-url="false"][data-product-id]'))
        .map((item) => item.dataset.productId)
        .filter(Boolean)
    );
    const allItems = Array.from(list.querySelectorAll('[data-featured-rotation-item]'));
    const items = allItems.filter((item) => !excludedProductIds.has(item.dataset.productId));
    const limit = Number.parseInt(list.dataset.featuredRotationCount, 10) || items.length;
    const selected = [];
    const shuffled = shuffle(items);

    addUnique(selected, shuffled.find((item) => hasCollection(item, ['nature', 'natural'])), limit);
    addUnique(selected, shuffled.find((item) => hasCollection(item, ['car', 'automobile', 'hood-ornament'])), limit);

    shuffle(shuffled).forEach((item) => addUnique(selected, item, limit));

    allItems.forEach((item) => {
      item.hidden = !selected.includes(item);
      item.classList.toggle('featured-rotation__item--active', selected.includes(item));
    });

    selected.forEach((item, index) => {
      item.style.setProperty('--animation-order', index + 1);
    });
  });
})();
